export const containerEntregasTab = {
    height: '100%',
    width: '100%',
    overflowY: 'auto'
}

export const containerProcurarEntregas = {
    padding: '5px 10px',
    borderBottom: '1px solid white',
    height: {
        lg: '30%',
        xl: '15%'
    }
}

export const containerCriaEntrega = {
    padding: '5px 10px',
    height: {
        lg: '13%',
        xl: '8%'
    }
}

export const containerListaEntregas = {
    overflowY: 'auto',
    padding: '5px 10px',
    height: {
        lg: '30%',
        xl: '52%'
    }
}

export const containerListaAguardando = {
    height: {
        lg: '27%',
        xl: '25%'
    },
    borderTop: '1px solid white'
}
